import styled from 'styled-components';

import { sizeUp, vars } from '~/theme';
import { Container as SlabIconContainer, slabIconVars } from '~atoms/SlabIcon';

export const Container = styled.div(({ theme }) => ({
  ...vars({
    [slabIconVars.size]: sizeUp('50rem', ['md', '60rem']),
  }),

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  height: slabIconVars.size,

  fontSize: sizeUp(theme.typography.size16, ['md', theme.typography.size20]),
  fontFamily: theme.typography.family.arial,

  [`${SlabIconContainer}`]: {
    boxShadow: '1rem 1rem 1rem 1rem rgba(0,0,0,0.5)',
  },
}));

export const TextArea = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',

  minWidth: sizeUp('170rem', ['md', '200rem']),
  height: '100%',
}));

export const InformationContainer = styled.section(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'flex-start',

  height: '100%',
}));

export const MaterialNameContainer = styled.span({
  fontWeight: 'bold',
});
